<template>
  <h2 class="title">WE ARE ELEGANT</h2>
  <section>
    <div class="text">
      <h2>BEAUTIFUL PRODUCTS</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis
        neque quis ex tincidunt vestibulum. Nam ultricies, ligula vel egestas
        porta, velit velit fringilla tellus, vel congue felis justo non risus.
      </p>
    </div>
    <div class="text">
      <h2>FAST DELIVERY</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis
        neque quis ex tincidunt vestibulum. Nam ultricies, ligula vel egestas
        porta, velit velit fringilla tellus, vel congue felis justo non risus.
      </p>
    </div>
    <div class="text">
      <h2>100% SATISFACTION</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lobortis
        neque quis ex tincidunt vestibulum. Nam ultricies, ligula vel egestas
        porta, velit velit fringilla tellus, vel congue felis justo non risus.
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 2rem;
  font-family: Poppins;
  font-weight: 650;
  color: #2b2b2b;
  text-transform: none;
  margin: 3rem auto;
}

section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  margin: auto;
  margin-bottom: 4rem;
  width: 80%;

  .text {
    grid-gap: 20px;
    text-align: center;

    h2 {
      font-family: Poppins;
      font-weight: 700;
      text-transform: none;
      line-height: 1.5;
      color: #2b2b2b;
    }

    p {
      font-family: Poppins;
      color: #2b2b2b;
      text-transform: none;
      margin: 0 10px;
      font-weight: 400;
    }
  }
}

@media screen and (max-width: 768px) {
  section {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
}
</style>
